import cn from 'classnames';
import { useWindowWidth } from 'src/hooks/useWindowWidth';

import { LinkWithAnchor } from '../LinkWithAnchor';
import s from './Banner.module.scss';

interface BannerProps extends React.HTMLAttributes<HTMLDivElement> {
  title: string;
  text?: string;
  image: string;
  buttonTitle?: string;
  link?: string;
  classNameLink?: string;
  buttonOnClickAction?: () => void;
  withoutShapes?: boolean;
  variant?: 'figure' | 'person';
  buttonID?: string;
}

export function Banner({
  title,
  text,
  image,
  variant = 'figure',
  buttonTitle,
  link,
  classNameLink = '',
  buttonOnClickAction,
  withoutShapes,
  buttonID,
  ...rest
}: BannerProps) {
  const {
    windowWidth,
    breakpoints: { SM, MD },
  } = useWindowWidth();
  let currentStyles = '';

  switch (variant) {
    case 'person':
      currentStyles = '--person';
      break;
    case 'figure':
    default:
      currentStyles = '';
      break;
  }

  let currentShape = '';

  if (!text) {
    currentShape =
      windowWidth && windowWidth > MD
        ? 'https://cdn.cloud.ru/backend/images/cloud-backup/banner-shape.png'
        : windowWidth && windowWidth > SM
        ? 'https://cdn.cloud.ru/backend/images/cloud-backup/banner-shape_tablet.png'
        : 'https://cdn.cloud.ru/backend/images/cloud-backup/banner-shape_mob.png';
  } else {
    currentShape =
      windowWidth && windowWidth > MD
        ? 'https://cdn.cloud.ru/backend/images/cloud-backup/banner-shape.png'
        : windowWidth && windowWidth > SM
        ? 'https://cdn.cloud.ru/backend/images/cloud-backup/banner-shape_tablet.png?v=1'
        : 'https://cdn.cloud.ru/backend/images/cloud-backup/banner-shape_mob-for-text.png?v=1';
  }

  return (
    <div
      className={`${s.root} c-constructor__banner ${currentStyles}`}
      data-qa="section"
      {...rest}
    >
      <div className={cn(s.wrapper, 'wrapper')}>
        <div
          className={`${s.card} c-constructor__banner-card ${
            text ? '--grid-card' : ''
          }`}
        >
          <div className={cn(s.content, 'c-constructor__banner-content')}>
            <p
              className={cn(s.title, 'c-constructor__banner-title')}
              dangerouslySetInnerHTML={{ __html: title }}
              data-qa="section_title"
            />
            {text && (
              <p
                className={cn(s.text, 'c-constructor__banner-text')}
                dangerouslySetInnerHTML={{ __html: text }}
              />
            )}
            {buttonTitle && (
              <LinkWithAnchor
                link={link}
                className={`${s.link} c-constructor__banner-link ${classNameLink}`}
                buttonTitle={buttonTitle}
                buttonOnClickAction={buttonOnClickAction}
                buttonID={buttonID}
              />
            )}
          </div>
          <img
            className={cn(s.image, 'c-constructor__banner-image')}
            src={image}
            alt=""
            data-qa="section_image"
          />
          {!withoutShapes && (
            <>
              <img
                className={cn(s.shape, 'c-constructor__banner-shape')}
                src={currentShape}
                alt=""
              />
            </>
          )}
        </div>
      </div>
    </div>
  );
}
